module.exports = __webpack_public_path__ + "img/0.1.d5cdf7b1.png";